import React from "react";
import { Button, Stack, Typography, Fade, Paper } from "@mui/material";
import FullPageLoader from "../system-components/loaders/FullPageLoader";
import HomeIcon from "@mui/icons-material/AppsTwoTone";
import { useNavigate } from "react-router-dom";

function NotFoundPage() {
    const [imageLoaded, setImageLoaded] = React.useState(false);
    const navigate = useNavigate();

    return (
        <Paper
            elevation={0}
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                height: "100vh",
                width: "100vw",
            }}
        >
            {!imageLoaded && <FullPageLoader />}
            <Fade in={imageLoaded} timeout={500}>
                <Stack
                    sx={{
                        maxWidth: "500px",
                        width: "100%",
                        display: imageLoaded ? "block" : "none",
                        margin: "auto",
                        p: 1,
                        boxSizing: "border-box",
                        textAlign: "center",
                    }}
                    spacing={2}
                >
                    <Typography
                        sx={{
                            textAlign: "center",
                            fontSize: "1.5rem",
                            fontWeight: "bold",
                        }}
                    >
                        Oh no! Page not found.
                    </Typography>
                    <img
                        style={{
                            objectFit: "contain",
                            width: "-webkit-fill-available",
                            borderRadius: "50%",
                        }}
                        onLoad={() => setImageLoaded(true)}
                        onError={() => setImageLoaded(true)}
                        src="/404_page.png"
                        alt="404"
                    />
                    <Button
                        variant="contained"
                        startIcon={<HomeIcon />}
                        sx={{
                            justifySelf: "center",
                            margin: "auto",
                        }}
                        onClick={() => navigate("/")}
                        size="large"
                    >
                        Back to Home
                    </Button>
                </Stack>
            </Fade>
        </Paper>
    );
}

export default NotFoundPage;
